function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useMemo } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import ButtonIcon from "./ButtonIcon";
var buttonStyleBase = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '1rem',
    transition: 'background-color ease-out 140ms, color ease-out 140ms, border-color ease-out 140ms',
    border: '1px solid transparent',
    borderRadius: '0.25rem',
    paddingTop: '0.5rem',
    paddingRight: '1rem',
    paddingBottom: '0.5rem',
    paddingLeft: '1rem',
    textDecoration: 'none'
};
var isAnchorButtonProps = function(element, propDrop) {
    return element === 'a';
};
var isButtonButtonProps = function(element, props) {
    return !isAnchorButtonProps(element, props);
};
var Button = function(_param) {
    var children = _param.children, iconBefore = _param.iconBefore, iconAfter = _param.iconAfter, iconStyle = _param.iconStyle, iconWrapperStyle = _param.iconWrapperStyle, isRtl = _param.isRtl, style = _param.style, _element = _param.element, element = _element === void 0 ? 'button' : _element, propDrop = _objectWithoutProperties(_param, [
        "children",
        "iconBefore",
        "iconAfter",
        "iconStyle",
        "iconWrapperStyle",
        "isRtl",
        "style",
        "element"
    ]);
    var rootCss = useMemo(function() {
        return [
            buttonStyleBase,
            style
        ];
    }, [
        style
    ]);
    var ButtonContent = _jsxs(_Fragment, {
        children: [
            iconBefore && _jsx(ButtonIcon, {
                icon: iconBefore,
                iconStyle: iconStyle,
                isRtl: isRtl,
                iconWrapperStyle: iconWrapperStyle,
                hasChildren: typeof children !== 'undefined'
            }),
            children,
            iconAfter && _jsx(ButtonIcon, {
                icon: iconAfter,
                iconStyle: iconStyle,
                isRtl: isRtl,
                iconWrapperStyle: iconWrapperStyle,
                hasChildren: typeof children !== 'undefined',
                reverseSpacing: true
            })
        ]
    });
    var ButtonElement = _jsx(_Fragment, {});
    if (isAnchorButtonProps(element, propDrop)) {
        var disabled = propDrop.disabled, testID = propDrop.testID, accessible = propDrop.accessible, accessibilityLabel = propDrop.accessibilityLabel, forwardedRef = propDrop.forwardedRef, href = propDrop.href, onClick = propDrop.onClick, rest = _objectWithoutProperties(propDrop, [
            "disabled",
            "testID",
            "accessible",
            "accessibilityLabel",
            "forwardedRef",
            "href",
            "onClick"
        ]);
        ButtonElement = _jsx("a", _objectSpread({}, rest, injectTestId(testID), {
            "aria-hidden": !accessible,
            "aria-label": accessibilityLabel,
            css: rootCss,
            ref: forwardedRef,
            onClick: !disabled ? onClick : undefined,
            href: disabled ? undefined : href,
            children: ButtonContent
        }));
    }
    if (isButtonButtonProps(element, propDrop)) {
        var disabled1 = propDrop.disabled, testID1 = propDrop.testID, accessible1 = propDrop.accessible, accessibilityLabel1 = propDrop.accessibilityLabel, forwardedRef1 = propDrop.forwardedRef, type = propDrop.type, rest1 = _objectWithoutProperties(propDrop, [
            "disabled",
            "testID",
            "accessible",
            "accessibilityLabel",
            "forwardedRef",
            "type"
        ]);
        ButtonElement = _jsx("button", _objectSpread({}, rest1, injectTestId(testID1), {
            "aria-hidden": !accessible1,
            "aria-label": accessibilityLabel1,
            css: rootCss,
            ref: forwardedRef1,
            disabled: disabled1,
            type: type || 'button',
            children: ButtonContent
        }));
    }
    return ButtonElement;
};
Button.defaultProps = {
    accessible: true,
    disabled: false,
    element: 'button'
};
Button.defaultStyle = _objectSpread({}, buttonStyleBase);
export default Button;
